export default __webpack_public_path__ + "static/media/logo-us-fabletics.735ea4c0.svg";